var _ObservableBaseClass_instances, _ObservableBaseClass_children, _ObservableBaseClass_subscribers, _ObservableBaseClass_currentValue, _ObservableBaseClass_isCompleted, _ObservableBaseClass_token, _ObservableBaseClass_addSubscriber, _ObservableBaseClass_removeSubscriber;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { IList, Maybe, MutableMap, noop } from '@noshiro/ts-utils';
import { issueObservableId, issueSubscriberId, issueToken, toSubscriber, } from '../utils';
export class ObservableBaseClass {
    constructor({ kind, type, depth, currentValueInit, }) {
        _ObservableBaseClass_instances.add(this);
        _ObservableBaseClass_children.set(this, void 0);
        _ObservableBaseClass_subscribers.set(this, void 0);
        _ObservableBaseClass_currentValue.set(this, void 0);
        _ObservableBaseClass_isCompleted.set(this, void 0);
        _ObservableBaseClass_token.set(this, void 0);
        this.kind = kind;
        this.type = type;
        this.depth = depth;
        this.id = issueObservableId();
        __classPrivateFieldSet(this, _ObservableBaseClass_currentValue, currentValueInit, "f");
        __classPrivateFieldSet(this, _ObservableBaseClass_children, [], "f");
        __classPrivateFieldSet(this, _ObservableBaseClass_subscribers, new MutableMap(), "f");
        __classPrivateFieldSet(this, _ObservableBaseClass_isCompleted, false, "f");
        __classPrivateFieldSet(this, _ObservableBaseClass_token, issueToken(), "f");
    }
    addChild(child) {
        __classPrivateFieldSet(this, _ObservableBaseClass_children, IList.push(__classPrivateFieldGet(this, _ObservableBaseClass_children, "f"), child), "f");
    }
    get currentValue() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_currentValue, "f");
    }
    getCurrentValue() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_currentValue, "f");
    }
    get isCompleted() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_isCompleted, "f");
    }
    get token() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_token, "f");
    }
    get hasSubscriber() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").size > 0;
    }
    get hasChild() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_children, "f").length > 0;
    }
    hasActiveChild() {
        return __classPrivateFieldGet(this, _ObservableBaseClass_children, "f").some((c) => !c.isCompleted);
    }
    setNext(nextValue, token) {
        __classPrivateFieldSet(this, _ObservableBaseClass_token, token, "f");
        __classPrivateFieldSet(this, _ObservableBaseClass_currentValue, Maybe.some(nextValue), "f");
        for (const s of __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").values()) {
            s.onNext(nextValue);
        }
    }
    // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-empty-function
    tryUpdate(_token) {
        throw new Error('not implemented');
    }
    tryComplete() {
        if (!this.hasSubscriber && !this.hasActiveChild()) {
            this.complete();
        }
    }
    complete() {
        if (this.isCompleted)
            return; // terminate only once
        // change state
        __classPrivateFieldSet(this, _ObservableBaseClass_isCompleted, true, "f");
        // run subscribers for the current value
        for (const s of __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").values()) {
            s.onComplete();
        }
        // remove all subscribers
        __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").clear();
        // propagate to children
        for (const o of __classPrivateFieldGet(this, _ObservableBaseClass_children, "f")) {
            o.tryComplete();
        }
    }
    chain(operator) {
        return operator(this);
    }
    subscribe(onNext, onComplete) {
        // first emit
        const curr = this.currentValue;
        if (Maybe.isSome(curr)) {
            onNext(curr.value);
        }
        if (this.isCompleted) {
            if (onComplete !== undefined) {
                onComplete();
            }
            return { unsubscribe: noop };
        }
        const id = __classPrivateFieldGet(this, _ObservableBaseClass_instances, "m", _ObservableBaseClass_addSubscriber).call(this, toSubscriber(onNext, onComplete));
        return {
            unsubscribe: () => {
                __classPrivateFieldGet(this, _ObservableBaseClass_instances, "m", _ObservableBaseClass_removeSubscriber).call(this, id);
            },
        };
    }
}
_ObservableBaseClass_children = new WeakMap(), _ObservableBaseClass_subscribers = new WeakMap(), _ObservableBaseClass_currentValue = new WeakMap(), _ObservableBaseClass_isCompleted = new WeakMap(), _ObservableBaseClass_token = new WeakMap(), _ObservableBaseClass_instances = new WeakSet(), _ObservableBaseClass_addSubscriber = function _ObservableBaseClass_addSubscriber(s) {
    // return the id of added subscriber
    const id = issueSubscriberId();
    __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").set(id, s);
    return id;
}, _ObservableBaseClass_removeSubscriber = function _ObservableBaseClass_removeSubscriber(id) {
    __classPrivateFieldGet(this, _ObservableBaseClass_subscribers, "f").delete(id);
};
